import {Typography} from '@mui/material';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import {A360CommissionSection} from '../CommissionSection';
import {getAdjustmentDetails} from 'Agent/Commissions/ducks/a360Commissions';
import {A360CommissionsSectionError, A360CommissionsSectionNoRecordsFound, LoadingSpinner} from '../Placeholders';
import {isAsyncServerError} from 'Core/models/Async';
import { formatCurrency } from 'Shared/utilities/FormatMoney';

export const AdjustmentDetails = () => {
  const {adjustmentDetails} = useSelector((state: ReducerState) => state.a360Commissions);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAdjustmentDetails());
  }, []);

  return (
    <A360CommissionSection
      title="Adjustment Details"
      className="a360-commissions__adjustment-details"
      aria-label="adjustment details"
    >
      {isAsyncServerError(adjustmentDetails) ? (
        <A360CommissionsSectionError error={adjustmentDetails.errorDetails} />
      ) : (
        renderAsyncView(
          adjustmentDetails,
          adjustmentDetailsList => (
            <>
              {Array.isArray(adjustmentDetailsList) && adjustmentDetailsList.length > 0 ? (
                <div className="a360-commissions__table-layout">
                  <table>
                    <thead>
                      <tr>
                        {[
                          'Adjustment Type',
                          'Check # If Applicable',
                          'Description',
                          'Process date of Adjustment',
                          'Amount',
                        ].map(colHeader => (
                          <th scope="col" key={colHeader}>
                            <Typography component="h3" sx={{fontWeight: 700}}>
                              {colHeader}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {adjustmentDetailsList.map(adjustment => (
                        <tr
                          key={`${adjustment.adjustmentType}-${adjustment.check ? adjustment.check : ''}-${
                            adjustment.dateOfAdjustment
                          }`}
                        >
                          <td style={{fontWeight: 700}}>{adjustment.adjustmentType}</td>
                          <td>{adjustment.check ? adjustment.check : ''}</td>
                          <td>{adjustment.description}</td>
                          <td>{adjustment.dateOfAdjustment}</td>
                          <td>{formatCurrency(adjustment.amount)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <A360CommissionsSectionNoRecordsFound />
              )}
            </>
          ),
          LoadingSpinner
        )
      )}
    </A360CommissionSection>
  );
};
